function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.192 7.588h3.933a.491.491 0 100-.983H3.192a.491.491 0 000 .983zM4.988 11.683a.491.491 0 00-.491-.491H1.875a.491.491 0 000 .983h2.622a.491.491 0 00.491-.492zM6.304 9.39a.491.491 0 00-.491-.491H.57a.491.491 0 100 .983h5.243a.49.49 0 00.491-.492z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.917 10.1l-1.914-5.141a.491.491 0 00-.461-.32h-5.079v-.505a1.132 1.132 0 00-1.128-1.133h-10.2a1.132 1.132 0 00-1.129 1.133v1a.491.491 0 10.982 0v-1a.151.151 0 01.146-.15h10.2a.15.15 0 01.146.15v10.513a.151.151 0 01-.146.151h-3.836a2.458 2.458 0 00-4.817 0H5.139a.151.151 0 01-.146-.151v-1a.491.491 0 10-.982 0v1a1.133 1.133 0 001.129 1.134h1.542a2.459 2.459 0 004.817 0h3.836a1.118 1.118 0 00.637-.2 1.175 1.175 0 00.656.2h.54a2.459 2.459 0 004.817 0h.867a1.126 1.126 0 001.147-1.1v-4.267a.1.1 0 010-.039.485.485 0 00-.082-.275zM9.09 16.763a1.475 1.475 0 111.475-1.475 1.476 1.476 0 01-1.475 1.475zm13.7-6.882h-2.391v-4.26h.806zm-3.21 6.882a1.475 1.475 0 111.476-1.475 1.476 1.476 0 01-1.48 1.475zm3.276-1.966h-.867a2.458 2.458 0 00-4.817 0h-.54c-.094 0-.165-.063-.165-.118V5.622h2.949v4.752a.492.492 0 00.492.491h3.113v3.814c-.003.055-.073.121-.168.121z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h24v20H0z"
});

var SvgOrders = function SvgOrders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgOrders, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Orders.69598cba.svg";
export { ForwardRef as ReactComponent };